export const pickFromPath = (url: string): string => {
  const [, , id] = url.split('/');
  return id;
};
